import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';
import Props from '@/components/app/product/components/price-info/sales-amount/type';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function SalesAmount({ value, isFree = false }: Props) {
  return (
    <Container center className='relative h-[65px] w-[75px] md:h-[75px] md:w-[87px]'>
      <XImage
        className='absolute'
        src={imagesList.icons.saleBackgroundIcon}
        alt={productLocalization.successfulSale}
        fill
      />
      <Container center className='flex-col'>
        <Text
          type={TEXT_TYPE.SPAN}
          className='productCount text-[22px] font-bold text-[#424244] md:text-[28px]'
        >
          {value}
        </Text>
        <Text type={TEXT_TYPE.SPAN} className='text-sm text-[#76767C]'>
          {isFree
            ? productLocalization.successfulDownload
            : productLocalization.successfulSale}
        </Text>
      </Container>
    </Container>
  );
}
